define(
  'modules/config',
  [
    'modules/utils'
  ],
  function (
    M_Utils
  ) {
    'use strict';

    function init (callback) {
      var config = getConfig();

      finaliseAssetPaths(config, 'audio');
      finaliseAssetPaths(config, 'assets');
      finaliseAssetPaths(config, 'streamingVideo');
      finaliseAssetPaths(config, 'backgroundImages');
      finaliseAssetPaths(config, 'navTileImages');
      finaliseAssetPaths(config, 'featureViews');
      finaliseAssetPaths(config, 'links');

      return callback(null, config);
    }

    function getConfig () {
      var settings = window.nxExperienceSettings;

      if ( !settings || !settings.experience ) {
        throw new Error('NX Experience configuration not found!');
      }

      addUAPropsToConfig(settings);

      return settings.experience;
    }

    function addUAPropsToConfig (settings) {
      if ( typeof UserAgent !== 'function' ) {
        throw new Error('Error adding UA props to NX Experience configuration'); 
      }

      var useragent = new UserAgent().parse(navigator.userAgent);
      useragent.isMobile = useragent.isMobile && !useragent.isTablet;

      settings.ua = useragent;
      settings.client.platform = useragent.isMobile && !useragent.isTablet ? 'Mobile' : useragent.isTablet ? 'Tablet' : 'PC';
    }

    // Prefix the relative asset paths in config using the assetRoot setting
    function finaliseAssetPaths (config, manifestProperty) {
      Object.keys(config.manifest[manifestProperty]).forEach(function (assetKey) {

        if (typeof config.manifest[manifestProperty][assetKey] === 'object' && Object.keys(config.manifest[manifestProperty][assetKey]).length > 0) {
          Object.keys(config.manifest[manifestProperty][assetKey]).forEach(function (assetSubKey) {
            
            if (typeof config.manifest[manifestProperty][assetKey][assetSubKey] === 'object' && Object.keys(config.manifest[manifestProperty][assetKey][assetSubKey]).length > 0) {
              Object.keys(config.manifest[manifestProperty][assetKey][assetSubKey]).forEach(function (assetSubSubKey) {

                var assetPath = config.manifest[manifestProperty][assetKey][assetSubKey][assetSubSubKey];
                config.manifest[manifestProperty][assetKey][assetSubKey][assetSubSubKey] = finalizePath(config, assetPath);
              })
            } else {
              var assetPath = config.manifest[manifestProperty][assetKey][assetSubKey];
              config.manifest[manifestProperty][assetKey][assetSubKey] = finalizePath(config, assetPath);
            }
          });
        } else {
          var assetPath = config.manifest[manifestProperty][assetKey];
          config.manifest[manifestProperty][assetKey] = finalizePath(config, assetPath);
        }
      })
    }

    function isAssetPath (assetPath) {
      return /\.\w{3}$/.test(assetPath);
    }

    function isRelativePath (assetPath) {
      return assetPath.indexOf('http') !== 0;
    }

    function finalizeAssetPath (config, assetPath) {

      return config.assetRoot + assetPath
    }

    function finalizePath (config, assetPath) {

      if ( isAssetPath(assetPath) && isRelativePath(assetPath) ) {

        return finalizeAssetPath(config, assetPath);

      }

      return assetPath;
    }

    function loadFile (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () { callback(this.status < 200 && this.status >= 300, this, this.responseText); };
      xhr.onerror = function () { callback(true, this); };
      xhr.open('GET', url, true);
      xhr.send();
    }

    return {
      init: init
    }
});

